import { useEffect } from "react";
import { useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { getTokenExternal } from "../../../utils/getTokenExternal";
import { DOCTOR_DINAMIC_SCHEDULE } from "../../../api/Routes";
import moment from "moment";
import Post from "../../../api/Post";
import Loading from "../Loading";

const ClbDoctorHorario = ({
  doctor,
  data,
  setData,
  items,
  setItems,
  indexDoctor,
  selectTime,
  setCountDr,
  doctorSelected,
}) => {
  const [selectedIndexTime, setSelectedIndexTime] = useState(-1);
  const [indexOfLast, setIndexOfLast] = useState(15);
  //temp
  const [loading, setLoading] = useState(true);
  const [horario, setHorario] = useState(null);
  const [allHorarios, setAllHorarios] = useState([]);
  const [aDays, setADays] = useState(7);
  const [startDay, setStartDay] = useState(0);
  //console.log(copyItems)
  useEffect(() => {
    const fecthHorarios = async () => {
      setLoading(true);
      try {
        const responseToken = await getTokenExternal({ id: 2 });
        //horarios
        let url = `${DOCTOR_DINAMIC_SCHEDULE}?doctorId=${
          doctor.id
        }&dateIni=${moment(new Date()).format("DD-MM-YYYY")}&dateEnd=${moment(
          new Date()
        )
          .add(7, "days")
          .format("DD-MM-YYYY")}&accountId=${data.patient.account.id}&link=${
          data?.linkAllianz ?? false
        }`;
        const response = await Post({
          url: url,
          data: {},
          access_token: responseToken.data.access_token,
          header: true,
        });
        //console.log(response)
        if (response.data.state) {
          const allkeys = Object.keys(response.data.data.response).sort(
            (a, b) =>
              moment(a).toDate().getTime() - moment(b).toDate().getTime()
          );
          const arrH = [];
          allkeys.forEach((ele) => {
            let objH = {
              key: ele,
              value: response.data.data.response[ele],
            };
            if (objH.value.length > 0) {
              arrH.push(objH);
            }
          });
          setADays(arrH.length);
          setAllHorarios(arrH);
          if (arrH.length > 0) {
            //console.log(arrH)
            setHorario(arrH[0]);
            let findIndex = items.data.findIndex(
              (el) => el.doctor.id === doctor.id
            );
            items.currentData[findIndex].values = arrH[0].value;
            setItems((prev) => ({
              ...prev,
              currentData: items.currentData,
            }));
          } else {
            setItems((prev) => ({
              ...prev,
              currentData: prev.currentData.filter(
                (it) => it.doctor.id !== doctor.id
              ),
            }));
          }
          if (items.doCount) setCountDr((prev) => prev - 1);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    fecthHorarios();
  }, [items.refetchSchedule]);
  //console.log(horario)
  //console.log(allHorarios)

  const minusDay = (n) => {
    let nDays = startDay - n;
    setStartDay(nDays);
    setHorario(allHorarios[nDays]);
  };
  const plusDay = (n) => {
    let nDays = startDay + n;
    setStartDay(nDays);
    setHorario(allHorarios[nDays]);
  };
  const dateComponent = (extraClasses = "") =>
    horario ? (
      <div className={`d-flex align-items-center ${extraClasses}`}>
        <div className="mr-3">
          {startDay > 0 && (
            <span className="bg-arrow" onClick={(e) => minusDay(1)}>
              <BsChevronLeft />
            </span>
          )}
        </div>
        <div className="mr-3">
          <div className="text-center">
            <span className="colorLabel fw-medium pr-2">
              {moment(horario.key, "YYYY-MM-DD").format("ddd")}
            </span>
            <span className="colorLabel">
              {moment(horario.key, "YYYY-MM-DD").format("DD MMM YYYY")}
            </span>
          </div>
        </div>
        <div className="mr-3">
          {startDay + 1 !== aDays && (
            <span className="bg-arrow" onClick={(e) => plusDay(1)}>
              <BsChevronRight />
            </span>
          )}
        </div>
      </div>
    ) : null;

  return (
    <div>
      <h5>
        {doctor.gender === "Female" ? "Dra." : "Dr."} {`${doctor.fullName}`}
      </h5>
      {dateComponent("")}
      <div>
        <div className="d-flex flex-wrap justify-content-start py-3">
          {loading && (
            <div className="pb-3 text-center">
              <Loading />
            </div>
          )}
          {!horario && !loading && (
            <div className="pb-3 text-center">
              <span>No existen horarios disponibles.</span>
            </div>
          )}
          {horario && (
            <>
              {horario.value.slice(0, indexOfLast).map((it, idx) => (
                <span
                  key={`time-${idx}`}
                  className={`${
                    selectedIndexTime === idx && doctor.id === doctorSelected
                      ? "box-time-active"
                      : ""
                  } box-time colorLink fw-medium m-1`}
                  onClick={() => {
                    selectTime(it, idx, doctor);
                    setSelectedIndexTime(idx);
                  }}
                >
                  {moment(it.hour, "HH:mm:ss").format("HH:mm")}
                </span>
              ))}
              {horario.value.length > 15 && indexOfLast === 15 && (
                <div className="py-2 text-center">
                  <span
                    className="colorLink"
                    style={{
                      textDecoration: "underline",
                      textDecorationThickness: "0px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIndexOfLast(horario.value.length)}
                  >
                    Mostrar más
                  </span>
                </div>
              )}
              {horario.value.length > 15 && indexOfLast > 15 && (
                <div className="py-2 text-center">
                  <span
                    className="colorLink"
                    style={{
                      textDecoration: "underline",
                      textDecorationThickness: "0px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIndexOfLast(15)}
                  >
                    Mostrar menos
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClbDoctorHorario;
